import polyglotI18nProvider from 'ra-i18n-polyglot';
import {
    Admin,
    CustomRoutes,
    Resource,
    // defaultDarkTheme, 
} from 'react-admin';
import { Route } from 'react-router';
import { ThemeProvider, createTheme } from '@mui/material';
// import { deepmerge } from '@mui/utils';
import englishMessages from './i18n/en';

import { Layout, Login } from './layout_v4';

import Regions from './region'
import MasterCustomer from './master_customers';
import MasterItems from './master_items';
import MasterChains from './master_chain';
import Distributors from './distributors';
import Features from './admin/features';
import ReportParams from './report_parameters';
import ReportSuites from './report_suites';
import ExcelReporting from './excel_reporting';
import DashboardDeployments from './dashboard_deployments'

import CustomItemGroups from './custom_item_groups'
import ProductBlacklist from './admin/blacklist_master_item'
import AuthorizedSuppliers from './admin/authorized_suppliers'
import Users from './admin/users'
import UserProfile from './user_profile'
import ExcelConnector from './admin/excel_connector_download'
import RegisterPage from './layout_v4/Register'
import ForgotPassword from './layout_v4/ForgotPassword'
import ResetPassword from './layout_v4/ResetPassword'
// import ContactWithTheme from './layout_v4/Contact'
import RegisterSuccessWithTheme from './layout_v4/RegisterSuccess'
import Distributor from './distributors'
import AuthProvider from 'authProvider';
import { FeatureContextProvider } from 'contexts/features'
import { ClientContextProvider, ClientContext } from 'contexts/client'
import MainDashboard from 'MainDashboard';
import { addTreeMethodsBasedOnParentAndPosition } from '@react-admin/ra-tree';
import { restClientWithOverrides } from 'transport-layer/src';
import ReportingOptionsDebug from './debug/ReportingOptionsDebug';

const i18nProvider = polyglotI18nProvider(
    locale => {
        if (locale === 'fr') {
            return import('./i18n/en').then(messages => messages.default);
        }

        // Always fallback on english
        return englishMessages;
    },
    'en',
    [
        { locale: 'en', name: 'English' },
        { locale: 'fr', name: 'Français' },
    ]
);

// const store = useStore(undefined, 'InfoBateCentral');

const App = () => {


    return (
        <ClientContextProvider>
            <FeatureContextProvider>
                <ClientContext.Consumer>
                    {({state}) => {
                        const {
                            CLIENT,
                            nameLabel: CLIENT_NAME,
                            customRoutes,
                            theme,
                            CUSTOM_RESOURCES,
                        } = state.client;
                        const dataProvider = {
                            ...addTreeMethodsBasedOnParentAndPosition(
                                restClientWithOverrides,
                                'parent_id',
                                'position',
                                false
                            ),
                        };
                        
                        // const darkTheme = deepmerge(defaultDarkTheme, { palette: { mode: 'dark' } });


                        return (
                            <Admin
                                title={CLIENT_NAME}
                                dataProvider={dataProvider}
                                // store={store}
                                authProvider={AuthProvider}
                                dashboard={MainDashboard}
                                loginPage={Login}
                                layout={Layout}
                                i18nProvider={i18nProvider}
                                disableTelemetry
                                // defaultTheme="light"
                                theme={theme}
                                // darkTheme={darkTheme}
                            >
                                <Resource name={`${CLIENT}_data_files`} />
                                <CustomRoutes>
                                    <Route path="/excel_connector" element={<ExcelConnector />} />
                                    <Route path="/user_profile" element={<UserProfile />} />
                                    <Route path="/debug/reporting-options" element={<ReportingOptionsDebug />} />
                                    {customRoutes.map((rt: any, idx: number) => (!rt.noLayout) ?
                                            <Route key={idx} path={rt.path} element={<rt.component />} />
                                            : null)
                                    }
                                </CustomRoutes>
                                <CustomRoutes noLayout>
                                    {/* <Route path="/contact" element={<ContactWithTheme/>} />, */}
                                    <Route path="/create_password" element={<ResetPassword />} />,
                                    <Route path="/forgot_password" element={<ForgotPassword />} />
                                    <Route path="/register" element={<RegisterPage />} />,
                                    <Route path="/registration_started" element={<RegisterSuccessWithTheme />} />,
                                    <Route path="/reset_password" element={<ResetPassword />} />,
                                    {customRoutes.map((rt: any, idx: number) => (rt.noLayout) ?
                                            <Route key={idx} path={rt.path} element={<rt.component />} />
                                            : null)
                                    }

                                </CustomRoutes>


                                {
                                    customRoutes.map((rt: any, idx: number) => (rt.noLayout) ?
                                        // <RouteWithoutLayout exact {...rt} key={idx} /> : <Route exact {...rt} key={idx}/>
                                        (<CustomRoutes key={idx}>
                                            <Route key={idx} {...rt} />
                                        </CustomRoutes>)
                                        : null)
                                }

                                {CUSTOM_RESOURCES.map((resource: any, idx: number) => ({ ...resource, 'key': idx }))}
                                <Resource name={`import_customer`} />
                                <Resource name={`${CLIENT}_fact_stores`} />
                                {/* base resources - All clients will have these */}
                                <Resource name={`${CLIENT}_region`} {...Regions} />
                                <Resource name={`${CLIENT}_data_files`} />
                                <Resource name={`${CLIENT}_data_thru`} />
                                <Resource name={`master_manufacturer`} />
                                <Resource name={`${CLIENT}_manufacturers`} />
                                <Resource name="data_suppliers" />
                                <Resource {...ProductBlacklist} name={`${CLIENT}_item_blacklist`} />
                                <Resource {...Features} name={`${CLIENT}_features`} />
                                <Resource name={`${CLIENT}_blacklist_item_autofilter`} />
                                <Resource {...DashboardDeployments} name={`${CLIENT}_dashboard_deployments`} />
                                <Resource {...ReportSuites} name={`${CLIENT}_report_suites`} />
                                <Resource {...ExcelReporting} name={`${CLIENT}_excel_reporting`} />
                                <Resource name={`${CLIENT}_item_group_associations`} />
                                <Resource {...ReportParams} name={`${CLIENT}_report_parameters`} />
                                <Resource name={`${CLIENT}_saved_item_group_items`} />
                                {/* <Resource name={`${CLIENT}_master_store_report_group_by_options`} /> */}
                                <Resource name={`${CLIENT}_master_store_report_attribute_options`} />
                                <Resource name={`${CLIENT}_master_item_report_attribute_options`} />
                                <Resource name={`${CLIENT}_period_wid`} />
                                <Resource {...Distributor} name={`${CLIENT}_distributor`} />
                                <Resource name={`${CLIENT}_master_distributor`} {...Distributors} />
                                <Resource name={'master_chain'} />
                                <Resource {...MasterChains} name={`${CLIENT}_master_chain`} />
                                <Resource {...MasterCustomer} name={`${CLIENT}_master_customers`} />
                                <Resource name='master_customer_history' />
                                <Resource name='master_customer_categories' />
                                <Resource name='master_item' />
                                <Resource {...MasterItems} name={`${CLIENT}_master_items`} />
                                <Resource name='product_categories' />
                                <Resource name={`${CLIENT}_saved_item_groups`} {...CustomItemGroups} />

                                <Resource name={`${CLIENT}_authorized_suppliers`} {...AuthorizedSuppliers} />
                                <Resource name={`${CLIENT}_warehouses`} />
                                <Resource name={`${CLIENT}_fact_groups`} />
                                <Resource name={`${CLIENT}_fact_manufacturers`} />
                                <Resource {...Users} />
                                <Resource name={`${CLIENT}_resource_telemetry`} />

                                <Resource name='user_api_keys' />
                                
                            </Admin>
                        )
                    }}
                </ClientContext.Consumer>
            </FeatureContextProvider>
        </ClientContextProvider>
    );
};

const AppWrapper = () => {
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
            },
        }
    });

    return (
        // <StoreContextProvider value={store}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        // </StoreContextProvider>
    );
}

export default AppWrapper;